import React, { useState } from 'react';
import { FaClipboardList } from 'react-icons/fa';
import LeadModal from './LeadModal';
import { reachGoal } from '../utils/metrika';
import './Supply.css';

const directions = [
  'Комплексные поставки электротехнического оборудования (шкафы Провенто, ДКС, взрывозащита, реле, частотники, источники питания, климат-контроль, пластиковые корпуса ЩМП, аксессуары)',
  'Взрывозащищённое оборудование Ex d / Ex e',
  'Сборка щитового оборудования',
  'OEM-производство под брендом заказчика',
  'Изготовление по чертежам от 10 дней'
];

const Supply = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

  return (
    <section className="supply-section">
      <div className="container-custom">
        <div className="supply-grid">
          <div className="supply-content">
            <h2 className="supply-title">
              <span className="supply-title-normal">ООО «Орион» — российский производитель и поставщик электротехнического оборудования</span>
            </h2>
            <p className="supply-desc">
              «АгораТех» — направление производства корпусов и шкафов из нержавеющей стали AISI 304/316, а также
              углеродистой стали с порошковой окраской. Полный цикл: конструкторская документация, лазерная резка,
              гибка, сварка, окраска, сборка.
            </p>
            <p className="supply-desc">
              <strong>Реквизиты:</strong><br />
              ООО «Орион»<br />
              ИНН: 5262377290<br />
              ОГРН: 1215200003930<br />
              Юр. адрес: 603089 г. Нижний Новгород, ул. Гаражная, д. 9, оф. 402
            </p>

            <div className="supply-card">
              <div className="supply-card-icon">
                <FaClipboardList />
              </div>
              <div className="supply-card-body">
                <h3 className="supply-card-title">Другие направления компании:</h3>
                <div className="supply-text">
                  {directions.map((item, index) => (
                    <p key={index}>— {item}</p>
                  ))}
                </div>
                <button type="button" className="supply-btn-dark" onClick={() => setIsLeadModalOpen(true)}>
                  Оставить заявку
                </button>
              </div>
            </div>
            
            <a href="tel:+78122373834" className="supply-btn-dark" onClick={() => reachGoal('clc-tel1')}>
              Позвонить
            </a>
          </div>
          
          <div className="supply-image">
            <img src="/images/supply.webp" alt="Производство шкафов из нержавеющей стали" />
          </div>
        </div>
      </div>
      <LeadModal show={isLeadModalOpen} onClose={() => setIsLeadModalOpen(false)} goalId="form-menu" />
    </section>
  );
};

export default Supply;
